import { Map } from 'immutable';
import types from '../constants/actionTypes';

const errors = (state, action) => {
  if (action.error) {
    if (action.payload.response.error) {
      state = state.push(Map({
        type: action.payload.statusText,
        message:  action.payload.response.error,
      }));
    } else {
      errorObjectToArray(action.payload.response).forEach(error =>
        state = state.push(Map({
          type: action.payload.statusText,
          message: error,
        }))
      );
    }
  }

  switch (action.type) {
    case types.errors.CLEAR_LAST_ERROR_MESSAGE:
      state = state.shift();
      break;
    case types.errors.ADD_MESSAGE:
      state = state.push(Map({
        type: action.status,
        message: action.message,
        autoHideDuration: action.autoHideDuration,
      }));
      break;
  }

  return state;
};

const errorObjectToArray = (obj) => {
  let errors = [];
  Object.keys(obj).forEach(key =>
    errors = errors.concat(obj[key].map(error => key + ' ' + error))
  );
  return errors;
};

export default errors;



/** WEBPACK FOOTER **
 ** ./reducers/errors.js
 **/